export const TeamResourceTypes = {
    PRESENTATION_TEMPLATES: "presentation-templates",
    TEAM_THEMES: "themes",
    TEAM_FOLDERS: "folders",
    TEAM_BRANDING_GUARDRAILS: "branding-guardrails",

    // Assets Resources
    TEAM_ASSETS: "assets",
    TEAM_ASSETS_IMAGES: "assets-images",
    SHARED_ASSETS_LOGOS: "shared-logos",

    PLAYER_SETTINGS: "player-settings",

    // slide Resources
    SHARED_SLIDES: "shared-slides",
    SLIDE_TEMPLATES: "slide-templates",
    SLIDES: "slides",
};

export const TEAM_SETTINGS_PANES = [
    TeamResourceTypes.PLAYER_SETTINGS,
    TeamResourceTypes.TEAM_BRANDING_GUARDRAILS,
    TeamResourceTypes.TEAM_FOLDERS,
];
